import React, { createContext, useReducer } from "react";
import Reducer from './Reducer'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { map } from "lodash";
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";

const initialState = {
    product_history: [],
};

const HistoryStore = ({ children }) => {
    const isMounted = useMounted()
    const [state, dispatch] = useReducer(Reducer, initialState);

    const fetch = async () => {

        const token = await AsyncStorage.getItem('userToken')
        const buyer = await AsyncStorage.getItem('buyerId')
        // let buyerData = await AsyncStorage.getItem('buyerData')
        let productHistory = await AsyncStorage.getItem('productHistory')

        // buyerData = JSON.parse(buyerData || '{}')
        productHistory = JSON.parse(productHistory || '[]')

        const do_dispatch = (obj) => {
            isMounted.current && dispatch(obj)
        }

        return new Promise(async (resolve, reject) => {

            do_dispatch({ type: 'SET_HISTORY', payload: productHistory });

            // read user's cart, if any exists
            let form = new FormData()
            form.append('buyer_id', buyer)
            http.post('product/buyer_single_history', form, token)
                .then(res => {
                    if (res.code === 200) {
                        let _list = res.data.products
                        _list = map(_list, (value, key) => {
                            return value
                        })
                        AsyncStorage.setItem('productHistory', JSON.stringify(_list))
                        do_dispatch({ type: 'SET_HISTORY', payload: _list })
                        resolve(_list)
                    } else {
                        // console.log(res.message)
                        reject(new Error(res.message))
                    }
                })
                .catch(err => {
                    // console.log(err)
                    reject(err)
                })


        })
    }

    return (
        <HistoryContext.Provider value={[state, dispatch, fetch]}>
            {children}
        </HistoryContext.Provider>
    )
};

export const HistoryContext = createContext(initialState);
export default HistoryStore;